import { render, staticRenderFns } from "./NotAllowedPage.vue?vue&type=template&id=799c8d7e&"
import script from "./NotAllowedPage.vue?vue&type=script&lang=js&"
export * from "./NotAllowedPage.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowedPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports